import { Box, styled } from '@mui/material';

export const TemplatePreview = styled(Box)({
  '& .sectionTitle': {
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '100%',
    letterSpacing: '0px',
    color: 'rgba(0, 0, 0, 1)',
  },

  '& .sectionAccordion': {
    width: '100% !important',
    boxShadow: 'none',
    '&:before': {
      display: 'none',
    },
  },

  '& .sectionAccordionSummary': {
    background: 'rgba(235, 234, 255, 1)',
    borderRadius: '8px',
  },

  '& .expandIcon': {
    width: 30,
    '& path': {
      color: 'rgba(33, 33, 33, 1)',
    },
  },

  '& .parentSectionTitle': {
    fontWeight: 600,
    fontSize: 13,
    lineHeight: '100%',
    letterSpacing: 0,
    color: 'rgba(78, 72, 250, 1)',
  },

  '& .connectIcon': {
    height: 17,
    marginTop: -3,
  },
});
